import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue'
import { addUserWithRole, removeUserWithRole } from '@/enitites/organization/api/endpoints'

import BKUserSelect from '@/components/BKUserSelect.vue'
import { Organization, OrganizationUser, UserRole } from '@/modules/Organizations/types'


export default /*#__PURE__*/_defineComponent({
  __name: 'CreateOrganizationPromoters',
  props: {
    org: null
  },
  emits: ["back", "end"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'back'): void
  (e: 'end'): void
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  org: Organization
};




const excludedUsersIds = computed(() => props.org.promoters.map((a) => a.id))

const addPromoter = async (user: OrganizationUser, role: UserRole) => {
  const resp = await addUserWithRole(props.org.id, user.id, role)
  if (resp) props.org.promoters.push(user)
}

const removePromoter = async (user: OrganizationUser, role: UserRole) => {
  const resp = await removeUserWithRole(props.org.id, user.id, role)
  if (resp) {
    props.org.promoters = props.org.promoters.filter((promoter) => promoter.id !== user.id)
  }
}

return { __sfc: true,props, emit, excludedUsersIds, addPromoter, removePromoter, BKUserSelect }
}

})